import axios from 'axios'
import { objectSnakeToCamelCase } from '@/util/libUtil.js'
import defaultDeviceForm from '@/util/management/defaultDeviceForm.js'
import defaultInstallmentForm from '@/util/management/defaultInstallmentForm.js'
import {clone} from '@/util/libUtil.js'

const state = () => ({
    isOpenDialog: false,
    deviceEdit: {
        form: clone(defaultDeviceForm),
        formType: 'EDIT',
        isOpenEditDialog: false,
    },
    currentInstallment: {
        form: clone(defaultInstallmentForm),
        formType: 'Edit',
        isOpenEditDialog: false,
    },
    deleteObject: {
        toDeleteId: '',
        toDeleteType: '',
        isOpenDeleteDialog: false,
    },
    tariffAdditionalOps: [],
    devicesDropDown: [],
    insurances: [],
    devices: [],
    installment: [],
    selectedDevice: null,
    loadingInstallments: false,
    isLoadingDevices: false,
    tableItemCount: null,
    paths: {
        devicesPath: '/api/servicios/terminales/',
        devicesDropDownPath: '/api/servicios/available-device-drop-down/',
        installmentsPath: '/api/servicios/installment/',
        tariffsByDevice: '/api/servicios/installments-terminal/',
        insurancePath: '/api/servicios/seguros/',
        tariffAdditionalOpPath: '/api/servicios/tariff-adicionales-drop-down/'
    }

})

const mutations = {
    deviceEditFormType: (state, val) => {
        state.deviceEdit.formType = val;
    },
    insurances: (state, val) => {
        state.insurances = val;
    },
    installmentFormType: (state, val) => {
        state.currentInstallment.formType = val;
    },
    isOpenEditInstallmentDialog: (state, val) => {
        state.currentInstallment.isOpenEditDialog = val;
    },
    tariffAdditionalOps: (state, val) => {
        state.tariffAdditionalOps = clone(val);
    },
    deleteObject: (state, val) => {
        state.deleteObject = clone(val);
    },
    editingInstallment: (state, val) => {
        state.currentInstallment.form = clone(val);
    },
    isOpenEditDialog: (state, val) => {
        state.deviceEdit.isOpenEditDialog = val;
    },
    editingDevice: (state, val) => {
        state.deviceEdit.form = clone(val);
    },
    isOpenDialog: (state, val) => {
        state.isOpenDialog = val;
    },
    isOpenDeleteDialog: (state, val) => {
        state.deleteObject.isOpenDeleteDialog = val;
    },
    devices: (state, val) => {
        state.devices = clone(val);
    },
    devicesDropDown: (state, val) => {
        state.devicesDropDown = clone(val);
    },
    installment: (state, val) => {
        state.installment = clone(val);
    },
    selectedDevice: (state, val) => {
        state.selectedDevice = val;
    },
    loadingInstallments: (state, val) => {
        state.loadingInstallments = val;
    },
    tableItemCount: (state, val) => {
        state.tableItemCount = val;
    },
    isLoadingDevices: (state, val) => {
        state.isLoadingDevices = val;
    }
}

const actions = {
    async updateDevice({ getters, state, dispatch, commit }) {
        try {
            await axios.put(getters.getEndpointFromPath(state.paths.devicesPath) + `${state.deviceEdit.form.id}/`, state.deviceEdit.form)
            let params = {
                page: 1,
                itemsPerPage: 20,
                is_active: 1
            };
            dispatch('getDevices', params)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Dispositivo Editado Correctamente",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Editar',
            }, { root: true })
        }
    },
    async createDevice({ getters, state, dispatch, commit }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.devicesPath), state.deviceEdit.form)
            let params = {
                page: 1,
                itemsPerPage: 20,
                is_active: 1
            };
            dispatch('getDevices', params)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Dispositivo Creado Correctamente",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Editar',
            }, { root: true })
        }
    },
    async updateInstallment({ getters, state, dispatch, commit }) {
        try {
            console.log(state.currentInstallment.form)
            await axios.put(getters.getEndpointFromPath(state.paths.installmentsPath) + `${state.currentInstallment.form.id}/`, state.currentInstallment.form)
            dispatch('getRelatedTariffs', state.deviceEdit.form)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Installment Editado Correctamente",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Editar',
            }, { root: true })
        }
    },
    async createInstallment({ getters, state, dispatch, commit }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.installmentsPath), state.currentInstallment.form)
            if(state.currentInstallment.formType != 'OFFER_CONFIGURATOR') dispatch('getRelatedTariffs', state.deviceEdit.form)

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Installment Editado Correctamente",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Editar',
            }, { root: true })
        }
    },
    async getTariffAdditionalOps({ dispatch, getters, state, commit }) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.tariffAdditionalOpPath))
            commit('tariffAdditionalOps', resp.data)

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Opciones Cargadas Correctamente'
            }, { root: true })
        }
        catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido'
            }, { root: true })
        }
    },
    async getInsurances({ dispatch, getters, state, commit }) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.insurancePath), {
                params: {
                    is_active: 1
                }
            })
            commit('insurances', resp.data)

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Seguros Cargados Correctamente'
            }, { root: true })
        }
        catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido'
            }, { root: true })
        }
    },
    async getDevices({ dispatch, getters, state, commit }, params) {
        try {
            commit('isLoadingDevices', true)
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.devicesPath), { params })
            commit('devices', resp.data.results)
            commit('tableItemCount', resp.data.count)
            commit('isLoadingDevices', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Terminales Cargados Correctamente'
            }, { root: true })
        }
        catch {
            commit('isLoadingDevices', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido'
            }, { root: true })
        }
    },
    async getDevicesDropDown({ dispatch, getters, state, commit }) {
        let resp = await axios.get(getters.getEndpointFromPath(state.paths.devicesDropDownPath))
        try {
            commit('devicesDropDown', resp.data)

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Dispositivos Cargados Correctamente'
            }, { root: true })
        }
        catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido'
            }, { root: true })
        }
    },
    async getRelatedTariffs({ dispatch, getters, state, commit }, terminal) {
        try {
            state.loadingInstallments = true
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.tariffsByDevice) + terminal.id + '/')
            state.loadingInstallments = false
            commit('installment', resp.data)
        }
        catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido'
            }, { root: true })
        }
    },
    async deleteInstallment({ state, dispatch, getters, rootState }, installment_id) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.installmentsPath) + installment_id + '/')
            dispatch('getRelatedTariffs', state.deviceEdit.form)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    },
    async deleteDevice({ state, dispatch, getters, rootState }, device_id) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.devicesPath) + device_id + '/')
            let params = {
                page: 1,
                itemsPerPage: 20,
                is_active: 1
            };
            dispatch('getDevices', params)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    }
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}